module.exports = __webpack_public_path__ + "img/logo-dutchrose.beaa1f76.png";